var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"gmap-trend",attrs:{"role":"img","aria-label":'租户近7日用电：' + _vm.points.map(p => p.date + '，' + p.value + '千瓦时').join('；')}})
}
var staticRenderFns = []

export { render, staticRenderFns }